@if (isLoadingCatalogos) {
<app-loader-common></app-loader-common>
}@else {

<div class="row">
    <h6 class="col-12 title-page">Factura Manual</h6>
</div>
<div class="row mt-2">
    <div class="col-12">
        <div class="container-fluid">
            <!-- Componente Datos Cabecera -->
            <app-form-cabecera (send_data_cabecera)="giveDataCabecera($event)"
                (send_validation_cabecera)="giveFormValidationCabecera($event)"></app-form-cabecera>

            <!-- Componente Datos Emisor -->
            <!-- <app-form-emisor (send_data_emisor)="giveDataEmisor($event)"
                (send_validation_emisor)="giveFormValidationEmisor($event)"></app-form-emisor> -->

            <!-- Componente Datos Receptor -->
            <app-form-receptor (send_data_receptor)="giveDataReceptor($event)"
                (send_validation_receptor)="giveFormValidationReceptor($event)"></app-form-receptor>

            <!-- Componente Datos de Conceptos -->
            <app-form-conceptos (send_data_impuestos_locales)="giveDataImpuestosLocales($event)"
                (send_data_concepto)="giveDataConcepto($event)" (send_data_impuestos)="giveDataImpuestos($event)"
                (send_data_totales_encabezados)="giveDataTotalEncabezado($event)"></app-form-conceptos>

        </div>
    </div>
</div>

<ng-template #longContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Facturado con éxito</h4>
        <button type="button" class="close" aria-label="Close" (click)="cerrarModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <!-- <<div *ngIf="xml">
        <h2>XML:</h2>
        <pre>{{ xml }}</pre>
      </div> -->
    <div class="modal-body d-flex justify-content-center align-items-center">
        <button type="button" class="btn btn-primary me-2" (click)="descargarZIP()">Descargar ZIP</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cerrarModal()">Cerrar</button>
    </div>
</ng-template>


<div class="row mt-5">
    <div class="col-12 text-end">
        <!-- <button class="btn btn-primary btn-sm me-3" (click)="open(content)">Previsualizar</button> -->
        <button class="btn btn-success btn-sm" (click)="generarCFDI(longContent)">Facturar</button>
    </div>
</div>


<app-custom-toaster></app-custom-toaster>


}